import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";

import {
  deleteWebhookSource,
  getWebhookSourceBySourceId,
  regenerateHmacKey,
  regenerateWebhookIdentifier,
} from "@gx/ts-contracts/services/webhook/api/webhook-WebhookSourceService_connectquery";

export const useGetWebhookSourceBySourceIdMutation = (
  options?: UseMutationOptions<
    typeof getWebhookSourceBySourceId.input,
    typeof getWebhookSourceBySourceId.output
  >,
) => {
  return useMutation<
    typeof getWebhookSourceBySourceId.input,
    typeof getWebhookSourceBySourceId.output
  >(getWebhookSourceBySourceId, {
    ...options,
  });
};

export const useRegenerateHmacKeyMutation = (
  options?: UseMutationOptions<typeof regenerateHmacKey.input, typeof regenerateHmacKey.output>,
) => {
  return useMutation<typeof regenerateHmacKey.input, typeof regenerateHmacKey.output>(
    regenerateHmacKey,
    {
      ...options,
    },
  );
};

export const useRegenerateWebhookIdentifierMutation = (
  options?: UseMutationOptions<
    typeof regenerateWebhookIdentifier.input,
    typeof regenerateWebhookIdentifier.output
  >,
) => {
  return useMutation<
    typeof regenerateWebhookIdentifier.input,
    typeof regenerateWebhookIdentifier.output
  >(regenerateWebhookIdentifier, {
    ...options,
  });
};

export const useDeleteWebhookSourceMutation = (
  options?: UseMutationOptions<typeof deleteWebhookSource.input, typeof deleteWebhookSource.output>,
) => {
  return useMutation<typeof deleteWebhookSource.input, typeof deleteWebhookSource.output>(
    deleteWebhookSource,
    {
      ...options,
    },
  );
};
